import { useMemo } from 'react'
import { useVenue } from './useVenue'
import { useWidgetSettings } from './useWidgetSettings'

export function usePriorityAlertsRequests({ partySize, requestsOnly }: { partySize?: number; requestsOnly?: boolean }) {
  const { priorityAlertsEnabled, priorityAlertsPartySizeMin, priorityAlertsPartySizeMax } = useVenue()
  const { enableRequests } = useWidgetSettings()
  return useMemo(
    () => [
      partySize !== undefined &&
        !requestsOnly &&
        priorityAlertsEnabled &&
        priorityAlertsPartySizeMin != null &&
        priorityAlertsPartySizeMax != null &&
        partySize >= priorityAlertsPartySizeMin &&
        partySize <= priorityAlertsPartySizeMax,
      partySize !== undefined && enableRequests,
    ],
    [enableRequests, partySize, priorityAlertsEnabled, priorityAlertsPartySizeMax, priorityAlertsPartySizeMin, requestsOnly]
  )
}
